// src/localstorage/index.ts
var getItem = (key) => {
  if (typeof localStorage !== "undefined" && "localStorage" in window) {
    return localStorage.getItem(key);
  }
  return null;
};
var setItem = (key, value) => {
  if (typeof localStorage !== "undefined") {
    localStorage.setItem(key, value);
  }
};
var removeItem = (key) => {
  if (typeof localStorage !== "undefined") {
    localStorage.removeItem(key);
  }
};

export {
  getItem,
  setItem,
  removeItem
};
//# sourceMappingURL=chunk-B5BMWS5T.mjs.map